import React, { Fragment } from 'react';
import styled from 'styled-components';
import Input from '@mui/material/Input';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import Tooltip from '@mui/material/Tooltip';
import SelectMui from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 400,
    },
  },
};

const MultiFilter = ({ value = [], options, onChange, placeholder, multiple = true }) => {
  
  const handleChangeMultiple = (event) => {
    const newVal = event.target.value;
    const prevAllChecked = value.indexOf('All') > -1;
    const allSelected = newVal.indexOf('All') > -1;
    if (prevAllChecked && !allSelected) {
      onChange([]);
      return;
    }
    if (allSelected) {
      onChange([...options]);
      return;
    }
    onChange(newVal);
  };

  return (
    <Fragment>
      <Select
        multiple={multiple}
        value={value}
        onChange={handleChangeMultiple}
        input={<Input />}
        renderValue={val => multiple ? '' : `: ${value}`}
        MenuProps={MenuProps}
        placeholder={placeholder}
      >
        {options.map((opt) => (
          <MenuItem key={opt} value={opt}>
            { multiple && <Checkbox checked={value.indexOf(opt) > -1} /> }
            <ListItemText primary={<TextWithTooltip>{opt}</TextWithTooltip>} />
          </MenuItem>
        ))}
      </Select>
    </Fragment>
  );
};

const Select = styled(SelectMui)`
  background-color: #fff;
  border: solid 1px #CBD6E2;
  border-radius: 4px;
  height: 46px;
  padding-left: 15px;
  max-width: 250px;
  &:before {
    display: none !important;

  }
  .MuiSelect-root {
    &:before {
      color: #535353 !important;
      font-size: 16px !important;
      font-weight: 400 !important;
      content: '${props => props.placeholder}';
      display: inline-block;
      padding-top: 3px;
    }
  }
`;

const TextWithTooltip = ({ children }) => (
	<Tooltip title={children}>
		<EllipsisText>
			{children}
		</EllipsisText>
	</Tooltip>
);

const EllipsisText = styled.div`
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export default MultiFilter;